import React, { useState, useEffect } from 'react';
import QRCodeBox from '@/components/qrCode/QRCode';
import Button, { ButtonTypes, ButtonStyles } from '@/components/button/Button';
import { IconsDictionary } from '@/components/icon/Icon.types';
import useCopyToClipboard from '@/hooks/useCopyToClipboard';
import SharePanelStyled from './SharePanel.styled';
import { CookieHelper } from '@/helpers/user/CookieHelper';
import PanelWrapper from '@/components/panelWrapper/PanelWrapper';

interface SharePanelProps {
  onClose: () => void;
}

const SharePanel = ({ onClose }: SharePanelProps) => {
  const url = window.location.toString();

  const [, copy] = useCopyToClipboard();
  const [text, setText] = useState<string>('');

  useEffect(() => {
    const timer = setTimeout(() => setText(''), 2000);
    return () => clearTimeout(timer);
  }, [copy]);

  const encodeBlocksConfig = () => {
    const blocksConfig = CookieHelper.GetCookie('x-block-config') || '';
    const newQueryString: string[] = [];

    const qs = blocksConfig.split('&');
    qs.map(str => {
      if (!str) return;
      const splitString = str.split('=');
      const key = splitString[0] || '';
      const value = splitString[1] || '';
      newQueryString.push(`${key}=${encodeURIComponent(value)}`);
    });

    if (blocksConfig) return newQueryString.join('&');
    else return null;
  };

  const blocksQS = encodeBlocksConfig() ? `&${encodeBlocksConfig()}` : '';
  const fullQS = `entry-versionstatus=${window?.ContensisEntryVersionStatus}${blocksQS}`;
  const symbol: '&' | '?' = url.toString().indexOf('?') !== -1 ? '&' : '?';
  const pathToCopy = `${url}${symbol}${fullQS}`;

  return (
    <PanelWrapper>
      <SharePanelStyled>
          <PanelWrapper.Header title="Share" onClose={onClose} />
            <div className="share-panel__container">
              <QRCodeBox path={pathToCopy} />
              <Button
                className="share-panel__button"
                type={ButtonTypes.Default}
                btnStyle={ButtonStyles.Secondary}
                icon={IconsDictionary.Link}
                iconColor="#444"
                label="Copy link"
                _onClick={() => {
                  setText('Link copied to clipboard');
                  copy(pathToCopy);
                }}
              />
              {text && <span className="share-panel__copied-text">{text}</span>}
            </div>
      </SharePanelStyled>
    </PanelWrapper>
  );
};

export default SharePanel;
